import { find } from "lodash-es"
import { useValueLists } from "../app/hooks"

const useValueListData = (listId: string, itemId: string) => {
  const lists = useValueLists()

  const list = find(lists, { valueListCode: listId })

  if (!list) {
    return itemId
  }

  const item = find(list.values, { code: itemId })

  if (!item) {
    return itemId
  }

  return item.value
}

export default useValueListData
